import React from "react";
import styled from "styled-components/macro";

interface TabHeaderProps {
	children?: React.ReactNode;
}

const TabHeader: React.FC<TabHeaderProps> = ({ children }) => {
	return <StyledHeader>{children}</StyledHeader>;
};

const StyledHeader = styled.header`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	height: var(--size-control-compact);
	border-bottom: var(--border-default);
	margin-bottom: var(--space-5);
	position: sticky;
	top: 0;
	z-index: 1;
	background-color: var(--color-surface);
	padding: 0 var(--space-5);
	svg {
		max-width: 12px;
	}
`;

export default TabHeader;
